import { createContext, useContext } from 'react';

export interface AuthEmployee {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  pin?: string;
  role: string;
  roleId?: string | null;
  roleName?: string | null;
  roleNames?: string[];
  roleIds?: string[];
  permissions?: string[];
  isActive: boolean;
  department?: string;
  position?: {
    id: string;
    name: string;
    department?: string;
  };
  hireDate: string;
  createdAt: string;
}

export interface AuthContextType {
  isAuthenticated: boolean;
  currentUser: AuthEmployee | null;
  setIsAuthenticated: (auth: boolean) => void;
  setCurrentUser: (user: AuthEmployee | null) => void;
  authChecked: boolean;
  setAuthChecked: (checked: boolean) => void;
  /** Permissions array for the current user (empty when logged out). */
  permissions: string[];
  /** Returns true if current user has the given permission slug. */
  hasPermission: (permission: string) => boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
